import { css } from 'lit';

export const posts = css`
  :host {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }
  * {
    box-sizing: border-box;
  }

  .loading-list {
    color: #eb008c;
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
  }
  .post-list {
    display: grid;
    grid-auto-rows: 1fr;
    width: 100%;
    gap: 1.875rem;
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) {
    .post-list {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (min-width: 1024px) {
    .post-list {
      grid-template-columns: repeat(3, 1fr);
      gap: 1.25rem;
    }
    single-post {
      width: 100%;
    }
  }
`;
